import { defineStore } from "pinia";
import { ref } from "vue";

export const useRouteStore = defineStore("routes", () => {
    const customRouter = ref({
        previousRoute: null,
        currentRoute: null,
        lastMainRoute: null,
        routes: [],
    });

    return {
        customRouter,
    };
});
